import angular from 'angular';

import { contactDetail } from './crm-directives/contact-detail.directive';
import { CreateCrmContactController } from './crm-directives/create-crm-contact.controller.js';
import { crmFormField } from './crm-directives/crm-form-field.directive.js';
import { crmSearchFieldMaterial } from './crm-directives/crm-search-field-material.directive.js';
import { searchAndLinkContact } from './crm-directives/search-and-link-contact.directive';
import { ExternalUserService } from './externalUser.services.js';
import { interactionWithOneSite } from './interaction-with-one-site.directive';
import { UserInteractionsMaterialController } from './user-interactions-material.controller';
import { UserService } from './user.services.js';


angular
  .module('user', [])
  .factory('UserFactory', UserService.UserFactory)
  .factory('ExternalUserFactory', ExternalUserService.ExternalUserFactory)
  .controller('UserInteractionsMaterialController', UserInteractionsMaterialController)
  .controller('CreateCrmContactController', CreateCrmContactController)
  .directive('interactionWithOneSite', interactionWithOneSite)
  .directive('searchAndLinkContact', searchAndLinkContact)
  .directive('contactDetail', contactDetail)
  .directive('crmFormField', crmFormField)
  .directive('crmSearchFieldMaterial', crmSearchFieldMaterial)
  ;